<template lang="pug">
  .res-card(:class="active? 'active' : ''")
    //tilt-card(v-if="checkInStatus!==0" :img="$t('home.card.res.imgRes')"  :copy="copy" @clicked="onRes" :notify="appStatus === 1" :resed="appStatus === 1")
    //tilt-card2(v-if="checkInStatus === 0")
    tilt-card(v-if="appStatus === 0" :img="$t('home.card.res.imgRes')"  :copy="copy" @clicked="onRes" :notify_event="true")
    tilt-card-resed(v-if="appStatus === 1")
    tilt-card-checkin(v-if="appStatus === 2")
  
</template>
<script>
import TiltCard from '@/components/home/TiltCard'
import { mapGetters, mapMutations, mapState } from 'vuex'
import AlipayService from '@/services/AlipayService'
import TiltCard2 from '@/components/home/TiltCardCheckin'
import TiltCardResed from '@/components/home/TiltCardResed'
import TiltCardCheckin from '@/components/home/TiltCardCheckin'
const resImg = require('src/assets/reservation.jpg')
export default {
  name: 'ResCard',
  components: { TiltCardCheckin, TiltCardResed, TiltCard2, TiltCard },
  props: {},
  data() {
    return {
      img: resImg,
      copy: {
         cn: '立即预约',
         en: 'Reservation',
         //cn: '',
         //en: '',
      },
      active: false,
      showQueue: true,
    }
  },
  computed: {
    ...mapState('app', ['user', 'appStatus']),
    // checkInStatus() {
    //   return this.user.checkin ? parseInt(this.user.checkin.status) : -1
    // },
    // ...mapGetters('app', ['getReses']),
    // showQueue() {
    //   console.log(this.getReses)
    //   // if (this.getReses) {
    //   for (res in this.getReses) {
    //     if (res.resStatus === 0) return true
    //   }
    //   // this.getReses.forEach((r) => {
    //   //   if (r.resStatus === 0) return true
    //   // })
    //   //}
    //
    //   return false
    // },
  },
  methods: {
    ...mapMutations('app', ['setRouterBack', 'showAgeWarning']),
    onRes() {
      this.$emit('res')
    },
    onClick() {
      if (this.appStatus === 0) this.$emit('res')
    },
    // onClick() {
    //   this.showAgeWarning()
    //   this.$router.replace('/reservation')
    //   this.setRouterBack('/')
    // },
    animeIn() {
      this.active = true
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.res-card
  width: 100%
  height: 100%
  opacity: 0
  &.active
    animation-name: CardFadeIn
    animation-duration: 0.7s
    animation-fill-mode: both
    animation-timing-function: $easeOutCubic
@keyframes CardFadeIn
  0%
    opacity: 0
    transform: scale(0.75) translateY(30%)
  100%
    opacity: 1
    transform: scale(1) translateY(0)
</style>
